import { Divider, Grid, Typography } from '@material-ui/core';
import React, { Component, Fragment, RefObject } from 'react';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import { SdkAction } from '../../../modules/tracelog';
import classnames from 'classnames';

const styles = (theme: Theme) => createStyles({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    padding: theme.spacing(3)
  },
  divider: {
    margin: `${theme.spacing(3)}px 0`
  },
  argumentKey: {
    padding: `${theme.spacing(1)}px 0`
  },
  argumentValue: {
    padding: `${theme.spacing(1)}px 0`
  },
  highlight: {
    backgroundColor: "hsla(60, 100%, 50%, 0.3)"
  }
})

type State = {
  hoverArgument: string | null
}

class MobileSdkViewer extends Component<Props> {
  contentRef = React.createRef<HTMLDivElement>();

  state = {
    hoverArgument: null
  }
  componentDidMount() {
    this.props.contentConsumer(this.contentRef);
  }

  setHoverArgument = (arg: string | undefined = undefined) => () => {
    this.setState({
      hoverArgument: (arg || null)
    })
  }

  renderMethodArguments = (args: { [key: string]: string }[]) => {
    const { classes } = this.props
    const { hoverArgument } = this.state

    let out: JSX.Element[] = []
    _.forEach(args, kvp => {
      _.forOwn(kvp, (v, k) => {
        out.push(<span key={k} onMouseEnter={this.setHoverArgument(k)} onMouseLeave={this.setHoverArgument()} className={hoverArgument === k ? classes.highlight : undefined}><strong>{k}</strong></span>)
      })
    })

    return out.map((e, i) => <Fragment key={i}>
      {i > 0 && ', '}
      {e}
    </Fragment>)
  }

  renderArguments = (args: { [key: string]: string }[]) => {
    const { classes } = this.props
    const { hoverArgument } = this.state

    if (args.length === 0)
      return <Grid item xs={12}><em>Function call has no arguments</em></Grid>

    let out: JSX.Element[] = []

    _.forEach(args, kvp => {
      _.forOwn(kvp, (v, k) => {
        out.push(<Fragment key={k}>
          <Grid item md={4} xs={12} className={classnames(classes.argumentKey, hoverArgument === k ? classes.highlight : null)}>
            <Typography variant="subtitle2">{k}:</Typography>
          </Grid>
          <Grid item md={8} xs={12} className={classnames(classes.argumentValue, hoverArgument === k ? classes.highlight : null)}>
            <Typography variant="body2">{this.renderArgument(v)}</Typography>
          </Grid>
        </Fragment>)
      })
    })

    return out
  }

  renderArgument = (v: any) => {
    if (v === null || v === undefined)
      return false
    else if (typeof v === "object")
      return JSON.stringify(v)
    else
      return v.toString()
  }

  render() {
    const { sdkAction, classes } = this.props;

    return <div ref={this.contentRef} className={classes.root}>
      <Typography variant="overline">{sdkAction.platform} {sdkAction.module} module</Typography>
      <Typography variant="h4">{sdkAction.method}({this.renderMethodArguments(sdkAction.arguments)})</Typography>
      <Divider className={classes.divider} />
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Typography variant="h6">Arguments</Typography>
          <Grid container>
            {this.renderArguments(sdkAction.arguments)}
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6">Return Value</Typography>
          <Typography variant="body2">{this.renderArgument(sdkAction.result) || <em>Function call has no return value</em>}</Typography>
        </Grid>
      </Grid>
    </div>
  }
}

interface Props extends WithStyles<typeof styles> {
  contentConsumer(ref: RefObject<HTMLElement>): void
  sdkAction: SdkAction
}

export default withStyles(styles)(MobileSdkViewer);